import { clsx } from "clsx";
import type { ReactNode } from "react";

/** The bordered surface with a condensed uppercase heading — the design language's "card"
 * (design-language.md, palette: surface is "header, cards, tray"). Four sheets had hand-rolled
 * this shell (review 2026-09-08: corruption-card, unit-items, and the entity page's Weapons and
 * Abilities), and their heading padding had already drifted apart.
 *
 * `inset` is the card's horizontal rhythm, not a heading tweak: the heading takes it and the
 * body's own rows repeat it. The Corruption card is `snug` because its pool figures and tier
 * blocks are full-bleed rows that set px-4 themselves; the three prose cards are `wide` and
 * pad their bodies px-6. The two values are the two that ship — the drift is preserved, not
 * resolved, because this change is behaviour-preserving. */
export function Card({
  title,
  inset = "wide",
  children,
}: {
  title: string;
  inset?: "wide" | "snug";
  children: ReactNode;
}) {
  return (
    <section className="rounded-lg border border-line bg-surface">
      <h2
        className={clsx(
          "border-b border-line-faint pt-3 pb-2 font-condensed text-[12.5px] font-semibold uppercase tracking-[0.16em] text-ink-3",
          inset === "snug" ? "px-4" : "px-6",
        )}
      >
        {title}
      </h2>
      {children}
    </section>
  );
}
